var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9116 19.1296L24.274 22.3203L19.2175 17.2955L24.3142 12.2304L29.9116 15.3981C30.242 15.5849 30.5168 15.856 30.708 16.1838C30.8992 16.5116 31 16.8843 31 17.2639C31 17.6434 30.8992 18.0161 30.708 18.3439C30.5168 18.6717 30.242 18.9428 29.9116 19.1296ZM0.161119 1.32912C0.0543637 1.58829 -0.000380618 1.86592 1.99177e-06 2.14621V32.3801C1.99177e-06 32.6922 0.0647363 32.9828 0.178381 33.2432L16.2253 17.2941L0.161119 1.32912ZM17.7214 15.808L22.4082 11.15L3.20076 0.280424C2.78906 0.0438351 2.30957 -0.0468932 1.8399 0.0229252L17.7214 15.808ZM17.7214 18.7815L1.89744 34.5091C2.32612 34.5609 2.77783 34.4861 3.20076 34.2458L22.3679 23.3992L17.7214 18.7815Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.7616c7eb50a1220136aeb5bd9f1202a8.svg";
export { ForwardRef as ReactComponent };